import { Types } from '../../Models/UserModel';
import * as ActionTypes from '../Actions/EnumTypes/ActionEnumTypes';
import { UserAction } from '../Actions/Models/UserActionModel';
import { EnumTypes } from '../../Models/EnumTypes/UserEnumTypes';
export type State = Types.UserStore;
export const initialState: State = {
    token: null,
    user: null,
    success: {},
    error: {},
    userList: [],
    noActiveUser: false,
    isLoggedIn: false,
    activeUser: null,
    userRoleFilter: EnumTypes.RoleName.TECHNICIAN,
    provinces: [],
    counties: []
    // userRoleFilter: undefined
};

export function userReducer(state: State = initialState, action: UserAction): State {
    switch (action.type) {
        case ActionTypes.User.LOG_IN_SUCCESS: {
            return {
                ...state,
                token: action.payload.token,
                user: action.payload.user,
                isLoggedIn: true,
                error: {
                    ...state.error,
                    loginErr: null
                }
            };
        }
        case ActionTypes.User.LOG_IN_FAILURE: {
            return {
                ...state,
                error: {
                    ...state.error,
                    loginErr: action.payload.error
                }
            };
        }
        case ActionTypes.User.LOG_IN_SUCCESS_NOT_PERMISSION: {
            return {
                ...state,
                error: {
                    ...state.error
                }
            };
        }
        case ActionTypes.User.RESET_PASSWORD_FAILURE: {
            return {
                ...state,
                error: {
                    ...state.error,
                    resetErr: action.payload.error
                },
                success: {
                    ...state.success,
                    resetSuccess: false
                }
            };
        }
        case ActionTypes.User.RESET_PASSWORD_SUCCESS: {
            return {
                ...state,
                error: {
                    ...state.error,
                    resetErr: null
                },
                success: {
                    ...state.success,
                    resetSuccess: true
                }
            };
        }
        case ActionTypes.User.RESET_PASSWORD_CONFIRM_SUCCESS: {
            return {
                ...state,
                error: {
                    ...state.error,
                    resetConfirmErr: null
                },
                success: {
                    resetConfirmSuccess: true
                }
            };
        }
        case ActionTypes.User.RESET_PASSWORD_CONFIRM_FAILURE: {
            return {
                ...state,
                error: {
                    ...state.error,
                    resetConfirmErr: action.payload.error
                },
                success: {
                    ...state.success,
                    resetConfirmSuccess: false
                }
            };
        }
        case ActionTypes.User.CHANGE_PASSWORD_SUCCESS: {
            return {
                ...state,
                error: {
                    ...state.error,
                    changePasswordErr: null
                },
                success: {
                    changePasswordSuccess: true
                }
            };
        }
        case ActionTypes.User.CHANGE_PASSWORD_FAILURE: {
            return {
                ...state,
                error: {
                    ...state.error,
                    changePasswordErr: action.payload.error
                },
                success: {
                    ...state.success,
                    changePasswordSuccess: false
                }
            };
        }
        case ActionTypes.User.LOG_OUT: {
            return {
                ...state,
                isLoggedIn: false,
                user: null,
                token: null,
                noActiveUser: true
            };
        }
        case ActionTypes.User.NO_ACTIVE_USER_FOUND: {
            return {
                ...state,
                noActiveUser: true
            };
        }
        case ActionTypes.User.CREATE_USER_SUCCESS: {
            return {
                ...state,
                error: {
                    ...state.error,
                    createUserErr: null
                },
                success: {
                    ...state.success,
                    createUserSuccess: true
                }
            };
        }
        case ActionTypes.User.CREATE_USER_FAILURE: {
            return {
                ...state,
                error: {
                    ...state.error,
                    createUserErr: action.payload.error
                },
                success: {
                    createUserSuccess: false
                }
            };
        }
        case ActionTypes.User.CLEAR_CREATE_USER_STATUS: {
            return {
                ...state,
                error: {
                    ...state.error,
                    createUserErr: null
                },
                success: {
                    createUserSuccess: null
                }
            };
        }
        case ActionTypes.User.ACTIVATE_USER_SUCCESS: {
            return {
                ...state,
                error: {
                    ...state.error,
                    activateUserErr: null
                },
                success: {
                    ...state.success,
                    activateUserSuccess: true
                }
            };
        }
        case ActionTypes.User.ACTIVATE_USER_FAILURE: {
            return {
                ...state,
                error: {
                    ...state.error,
                    activateUserErr: action.payload.error
                },
                success: {
                    activateUserSuccess: false
                }
            };
        }
        case ActionTypes.User.BEGIN_ACTIVATE_USER_SUCCESS: {
            return {
                ...state,
                error: {
                    ...state.error,
                    beginActivateUserErr: null
                },
                success: {
                    ...state.success,
                    beginActivateUserSuccess: true
                }
            };
        }
        case ActionTypes.User.BEGIN_ACTIVATE_USER_FAILURE: {
            return {
                ...state,
                error: {
                    ...state.error,
                    beginActivateUserErr: action.payload.error
                },
                success: {
                    ...state.success,
                    beginActivateUserSuccess: false
                }
            };
        }
        case ActionTypes.User.GET_USER_LIST_WITH_FILTERS_SUCCESS: {
            return {
                ...state,
                error: {
                    ...state.error,
                    getUserListErr: null
                },
                success: {
                    ...state.success,
                    getUserListSuccess: true
                },
                userList: action.payload.userList
            };
        }
        case ActionTypes.User.GET_USER_LIST_SUCCESS: {
            return {
                ...state,
                userList: [...state.userList, ...action.payload.userList]
            };
        }
        case ActionTypes.User.GET_USER_LIST_FAILURE: {
            return {
                ...state,
                error: {
                    ...state.error,
                    getUserListErr: action.payload.error
                },
                success: {
                    ...state.success,
                    getUserListSuccess: false
                }
            };
        }
        case ActionTypes.User.SET_ACTIVE_USER:
            return {
                ...state,
                activeUser: action.payload.activeUser
            };
        case ActionTypes.User.SET_ROLE_FILTER:
            return {
                ...state,
                userRoleFilter: action.payload.userRole
            };
        case ActionTypes.User.UNBLOCK_ACTIVE_USER: {
            const activeUser = { ...state.activeUser };
            activeUser.status = EnumTypes.Status.NOT_ACTIVE;
            const userList = [...state.userList];
            const activeUserIdx = userList.findIndex((e, i) => e.id === activeUser.id);
            userList[activeUserIdx].status = EnumTypes.Status.NOT_ACTIVE;
            return {
                ...state,
                activeUser,
                userList
            };
        }
        case ActionTypes.User.BLOCK_ACTIVE_USER: {
            const activeUser = { ...state.activeUser };
            activeUser.status = EnumTypes.Status.BLOCKED;
            const userList = [...state.userList];
            const activeUserIdx = userList.findIndex((e, i) => e.id === activeUser.id);
            userList[activeUserIdx].status = EnumTypes.Status.BLOCKED;
            return {
                ...state,
                activeUser,
                userList
            };
        }
        case ActionTypes.User.UPDATE_VOIVODESHIPS: {
          return {
            ...state,
            provinces: action.payload.voivodeships
          }
        }
        case ActionTypes.User.UPDATE_COUNTIES: {
          return {
            ...state,
            counties: action.payload.counties
          }
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/UserReducer.ts